import React, {useState, useEffect} from 'react';
import {Grid , Chip, ListItem, ListItemIcon, ListItemText, Divider} from '@material-ui/core/';
import { useStyles } from "./style";
import {functions} from 'constants/index'
//REDUX
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';

import {AccountCircle, Email, Filter1, Today, LocationOn, Call, Wc, Person} from '@material-ui/icons';

function DatosCiudadano(props) {   
    // console.log('props ', props)
    const classes = useStyles()
    return (
        <Grid container >
            <Grid item xs={12}>
                <div className={classes.centerTitle}><Divider /> <strong>DATOS DEL CIUDADANO</strong> <Divider /></div>
            </Grid >             
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText}  primary="Nombre completo: " />
                    <ListItemIcon className={classes.colorIcon}><AccountCircle/></ListItemIcon>
                </ListItem>
            </Grid >                
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip}  
                label={(props.datosCiudadanoTable.primerNombre ? props.datosCiudadanoTable.primerNombre : '') +' '+(props.datosCiudadanoTable.segundoNombre ? props.datosCiudadanoTable.segundoNombre : '')+ ', ' +
                (props.datosCiudadanoTable.primerApellido ? props.datosCiudadanoTable.primerApellido : '')+ ' '+ (props.datosCiudadanoTable.segundoApellido ? props.datosCiudadanoTable.segundoApellido : '') + ', '+
                (props.datosCiudadanoTable.tercerApellido ? props.datosCiudadanoTable.tercerApellido : '')} />                                
            </Grid >                
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText}  primary="Sexo: " />
                    <ListItemIcon className={classes.colorIcon} ><Wc/></ListItemIcon>
                </ListItem>
            </Grid >                
            <Grid item xs={3}>
                { props.datosCiudadanoTable.genero === 1 ? <Chip variant="outlined" className={classes.colorChip} label="Masculino"/> 
                    : <Chip variant="outlined" className={classes.colorChip} label="Femenino"  /> 
                }
            </Grid >                
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Alfabetismo: " />
                    <ListItemIcon className={classes.colorIcon}><Person/></ListItemIcon>
                </ListItem>                
            </Grid >                
            <Grid item xs={3}>
                { props.datosCiudadanoTable.alfabetismo === 0 ? <Chip variant="outlined" className={classes.colorChip} label="No lee, No escribe"/>
                    : props.datosCiudadanoTable.alfabetismo === 1 ? <Chip variant="outlined" className={classes.colorChip} label="Si lee"/> 
                    : props.datosCiudadanoTable.alfabetismo === 2 ? <Chip variant="outlined" className={classes.colorChip} label="Si escribe"/> 
                    : <Chip variant="outlined" className={classes.colorChip} label="Si lee, Si escribe"/> 
                }                
            </Grid >                
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Vista: " />
                    <ListItemIcon className={classes.colorIcon}><Person/></ListItemIcon>
                </ListItem>                
            </Grid >
            <Grid item xs={3}>
                { 
                    props.datosCiudadanoTable.noVidente === 2 ? <Chip variant="outlined" className={classes.colorChip} label="No Definido"  />
                    : props.datosCiudadanoTable.noVidente === 1 ? <Chip variant="outlined" className={classes.colorChip} label="No vidente"  /> 
                    : props.datosCiudadanoTable.noVidente === 0 ? <Chip variant="outlined" className={classes.colorChip} label="Vidente"  /> 
                    : ''
                }
            </Grid >                
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Fecha de Nacimiento: " />
                    <ListItemIcon className={classes.colorIcon}><Today/></ListItemIcon>
                </ListItem>                
            </Grid >                
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} label={props.datosCiudadanoTable.fechaNacimiento ? (functions.splitDate(props.datosCiudadanoTable.fechaNacimiento)): ''}  />                                
            </Grid >                            
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Fecha de Asiento de Nacimiento: " />
                    <ListItemIcon className={classes.colorIcon}><Today/></ListItemIcon>
                </ListItem>                
            </Grid >                
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} label={props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento?.fechaAsientoNacimientoDPI ? functions.splitDate(props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento?.fechaAsientoNacimientoDPI) : ''}  />                                
            </Grid >                
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Lugar de Nacimiento: " />
                    <ListItemIcon className={classes.colorIcon}><LocationOn/></ListItemIcon>
                </ListItem>                
            </Grid >                
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} 
                label={(props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento?.departamentoNacimiento?.name ? props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento?.departamentoNacimiento?.name : '')+', '+ 
                (props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento?.municipioNacimieno?.name ? props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento?.municipioNacimieno?.name : '')} />
            </Grid >                 
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Libro: " />
                    <ListItemIcon className={classes.colorIcon}><Filter1/></ListItemIcon>
                </ListItem>                
            </Grid >                
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} label={(props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento?.numeroLibroNacimientoDPI ? props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento?.numeroLibroNacimientoDPI : '')}/>                                
            </Grid >                
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Fecha Nacionaliza: " />
                    <ListItemIcon className={classes.colorIcon}><Today/></ListItemIcon>
                </ListItem>                
            </Grid >                
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} label={(props.datosCiudadanoTable.complementoSolicitudesEmpadronamiento?.fechaNacionalizacion ? functions.splitDate(props.datosCiudadanoTable.complementoSolicitudesEmpadronamiento?.fechaNacionalizacion) : '')} />
            </Grid >                           
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Folio: " />
                    <ListItemIcon className={classes.colorIcon}><Filter1/></ListItemIcon>
                </ListItem>                
            </Grid >                
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} label={(props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento?.numeroFolioNacimientoDPI ? props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento?.numeroFolioNacimientoDPI : '')}/>                                
            </Grid >                
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Lugar de Residencia: " />
                    <ListItemIcon className={classes.colorIcon}><LocationOn/></ListItemIcon>
                </ListItem>                
            </Grid >                
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} 
                label={(props.datosCiudadanoTable?.departamentoResidencia?.name ? props.datosCiudadanoTable?.departamentoResidencia?.name : '')+', '+
                (props.datosCiudadanoTable?.municipioResidencia?.name ? props.datosCiudadanoTable?.municipioResidencia?.name : '')} />
            </Grid >             
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Partida: " />
                    <ListItemIcon className={classes.colorIcon}><Filter1/></ListItemIcon>
                </ListItem>                                    
            </Grid >                
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} label={(props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento?.numeroPartidaNacimientoDPI ? props.datosCiudadanoTable.datosDpiSolicitudEmpadronamiento?.numeroPartidaNacimientoDPI : '')} />                                
            </Grid >                
               
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Dirección de Residencia: " />
                    <ListItemIcon className={classes.colorIcon}><LocationOn/></ListItemIcon>
                </ListItem>                
            </Grid >                
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} label={(props.datosCiudadanoTable?.direccion ? props.datosCiudadanoTable?.direccion : '')} />
            </Grid >                
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Teléfono: " />
                    <ListItemIcon className={classes.colorIcon}><Call/></ListItemIcon>
                </ListItem>                
            </Grid >                
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} label={(props.datosCiudadanoTable.complementoSolicitudesEmpadronamiento?.telefono ? props.datosCiudadanoTable.complementoSolicitudesEmpadronamiento?.telefono : '')} />                                
            </Grid >                
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem} >
                    <ListItemText className={classes.rootListItemText} primary="Nombre del Padre: " />
                    <ListItemIcon className={classes.colorIcon}><Person/></ListItemIcon>
                </ListItem>                
            </Grid >
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} 
                label={(props.datosCiudadanoTable.complementoSolicitudesEmpadronamiento?.primerNombrePadre ? props.datosCiudadanoTable.complementoSolicitudesEmpadronamiento?.primerNombrePadre : '')
                    +' '+(props.datosCiudadanoTable.complementoSolicitudesEmpadronamiento?.segundoNombrePadre ? props.datosCiudadanoTable.complementoSolicitudesEmpadronamiento?.segundoNombrePadre : '')+', '+
                        (props.datosCiudadanoTable.complementoSolicitudesEmpadronamiento?.primerApellidoPadre ? props.datosCiudadanoTable.complementoSolicitudesEmpadronamiento?.primerApellidoPadre : '' )
                    +' '+(props.datosCiudadanoTable.complementoSolicitudesEmpadronamiento?.segundoApellidoPadre ? props.datosCiudadanoTable.complementoSolicitudesEmpadronamiento?.segundoApellidoPadre: '' )}/>                                
            </Grid >            
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Nombre de la Madre: " />
                    <ListItemIcon className={classes.colorIcon}><Person/></ListItemIcon>
                </ListItem>                
            </Grid >                
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} 
                label={(props.datosCiudadanoTable.complementoSolicitudesEmpadronamiento?.primerNombreMadre ? props.datosCiudadanoTable.complementoSolicitudesEmpadronamiento?.primerNombreMadre : '')
                    +' '+ (props.datosCiudadanoTable.complementoSolicitudesEmpadronamiento?.segundoNombreMadre ? props.datosCiudadanoTable.complementoSolicitudesEmpadronamiento?.segundoNombreMadre :'')+', '+
                    (props.datosCiudadanoTable.complementoSolicitudesEmpadronamiento?.primerApellidoMadre ? props.datosCiudadanoTable.complementoSolicitudesEmpadronamiento?.primerApellidoMadre : '') 
                    +' '+(props.datosCiudadanoTable.complementoSolicitudesEmpadronamiento?.segundoApellidoMadre ? props.datosCiudadanoTable.complementoSolicitudesEmpadronamiento?.segundoApellidoMadre : '')} />                                
            </Grid >               
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Correo electrónico: " />
                    <ListItemIcon className={classes.colorIcon}><Email/></ListItemIcon>
                </ListItem>
            </Grid >                
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} label={(props.datosCiudadanoTable.complementoSolicitudesEmpadronamiento?.email ? props.datosCiudadanoTable.complementoSolicitudesEmpadronamiento?.email : '')} />                                
            </Grid >                
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="Profesión: " />
                    <ListItemIcon className={classes.colorIcon}><Person/></ListItemIcon>
                </ListItem>                
            </Grid >                
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} label={(props.datosCiudadanoTable.complementoSolicitudesEmpadronamiento?.profesionName?.name ? props.datosCiudadanoTable.complementoSolicitudesEmpadronamiento?.profesionName?.name : '')}  />                                
            </Grid >                                         
        </Grid>
    );
}


export default connect(mapStateToProps, mapDispatchToProps)(DatosCiudadano);